import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import heroBg from "./assets/driverHero.jpg";
import bike from "./assets/bike.png";
import mini from "./assets/mini1.png";
import sedan from "./assets/sedan.png";
import suv from "./assets/suv1.png";
import auto from "./assets/auto.png";
import evcar from "./assets/Ev2.png";
import rolopink from "./assets/rolopink.png";
import micro from "./assets/car1.png";
import support from "./assets/becomedriver/support.jpg";
import emergency from "./assets/becomedriver/emergency.jpg";
import tracking from "./assets/becomedriver/tracking.jpg";
import payment from "./assets/becomedriver/payment.jpg";
import community from "./assets/becomedriver/community.jpg";
import LinkedIn from "./assets/logo/LinkedIn.png";
import twitter from "./assets/logo/twitter.png";
import insta from "./assets/logo/insta.png";
import fb from "./assets/logo/fb.png";
import { useState } from "react";
import { sendContactMessage } from "./services/authService";
import { toast } from "react-toastify";

function BecomeDriver() {
  const [userType, setUserType] = useState("");
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_no: "",
    you_are: "",
    organization_name: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
    const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showDriverMenu, setShowDriverMenu] = useState(false);


 const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ NAME → allow only letters & space
  if (name === "name") {
    const onlyText = value.replace(/[^A-Za-z ]/g, "");
    setFormData({ ...formData, name: onlyText });
    return;
  }

  // ✅ CONTACT → only numbers + max 10 digits
  if (name === "mobile_no") {
    const onlyNumbers = value.replace(/[^0-9]/g, "").slice(0, 10);
    setFormData({ ...formData, mobile_no: onlyNumbers });
    return;
  }

  // default
  setFormData({
    ...formData,
    [name]: value,
  });
};




  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await sendContactMessage(formData);

      if (res.success === "1") {
        toast.success(res.message); // ✅ SUCCESS TOAST

        setFormData({
          name: "",
          email: "",
          mobile_no: "",
          you_are: "",
          organization_name: "",
          message: "",
        });
      } else {
        toast.error(res.message); // fallback
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.message || "Failed to send message. Try again."); // ❌ ERROR TOAST
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="driver-page">
      <Navbar />

      {/* HERO */}
      <section
        className="driver-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h1>
            Drive Earn <br /> Grow with Rolo Transit
          </h1>

          <p>
            Earn on your own terms with flexible hours,
            <br /> transparent payouts, and steady ride opportunities.
          </p>

        <div style={{ position: "relative", display: "inline-block" }}>
  <button
    className="hero-btn"
    onClick={() => setShowDropdown(!showDropdown)}
  >
    Become a driver
  </button>
    {showDropdown && (
<div
  style={{
    position: "absolute",
    top: "110%",
    left: 0,
    minWidth: "220px",
    padding: "10px",
    borderRadius: "18px",
    background: "rgba(20, 20, 20, 0.95)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow:
      "0 10px 30px rgba(0,0,0,0.35), 0 0 20px rgba(252,147,68,0.15)",
    zIndex: 1000,
    overflow: "hidden",
  }}
>
  <a
    href="https://play.google.com/store/apps/details?id=com.rolocabs"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(61, 220, 132, 0.15)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-android"
      style={{
        color: "#3DDC84",
        fontSize: "22px",
      }}
    />
    Android
  </a>

  <a
    href="YOUR_IOS_APP_LINK"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.12)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-apple"
      style={{
        color: "#ffffff",
        fontSize: "22px",
      }}
    />
    iOS
  </a>
</div>
    )}
</div>
        </div>
      </section>

      {/* WHY DRIVE */}
      <section className="why-drive">
        <h2>Why drive with Rolo</h2>

        <div className="why-grid">
          <div className="why-card">
            <h4>Flexible Hours</h4>
            <p>Drive when it suits your schedule</p>
          </div>

          <div className="why-card">
            <h4>Competitive Earnings</h4>
            <p>Fair fares and transparent payouts</p>
          </div>

          <div className="why-card">
            <h4>Quick Onboarding</h4>
            <p>Simple registration and fast approval</p>
          </div>
        </div>
      </section>

      {/* WAYS TO EARN */}
<section className="earn-section">
  <h2>Multiple Ways to Earn</h2>

  <div className="earn-grid">
    {[
      { title: "City Pick & Drop", icon: "/icons/icon1.png" },
      { title: "Outstation Rides", icon: "/icons/icon2.png" },
      { title: "Carpooling (City & Outstation)", icon: "/icons/icon3.png" },
      { title: "Rentals", icon: "/icons/icon4.png" },
      { title: "Delivery & Porter Services", icon: "/icons/icon5.png" },
      { title: "Emergency Rides", icon: "/icons/icon6.png" },
    ].map((item, index) => (
      <div className="hex-wrapper" key={index}>
        <div className="hex-border">
          <div className="hex-content">
            <img src={item.icon} alt={item.title} />
            <p>{item.title}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>

      {/* VEHICLES */}
      <section className="vehicle-types">
        <h2>Vehicle Types We Accept</h2>

        <div className="vehicle-grid">
          <div className="vehicle-card">
            <span>Bike</span>
            <img src={bike} alt="" />
          </div>

          <div className="vehicle-card">
            <span>Mini</span>
            <img src={mini} alt="" />
          </div>

          <div className="vehicle-card">
            <span>EV (Rolo Green)</span>
            <img src={evcar} alt="" />
          </div>

          <div className="vehicle-card">
            <span>Auto</span>
            <img src={auto} alt="" />
          </div>

          <div className="vehicle-card">
            <span>Sedan</span>
            <img src={sedan} alt="" />
          </div>

          <div className="vehicle-card">
            <span>Rolo Pink</span>
            <img src={rolopink} alt="" />
          </div>

          <div className="vehicle-card">
            <span>Micro</span>
            <img src={micro} alt="" />
          </div>

          <div className="vehicle-card">
            <span>SUV</span>
            <img src={suv} alt="" />
          </div>
        </div>
      </section>

      {/* SAFETY */}
      <section className="safety">
        <h2>Your Safety Comes First</h2>

        <div className="safety-grid">
          <div className="safety-item">
            <div className="safety-img">
              <img src={support} alt="support" />
            </div>
            <p>24/7 Driver Support</p>
          </div>

          <div className="safety-item">
            <div className="safety-img">
              <img src={emergency} alt="emergency" />
            </div>
            <p>In-App Emergency Assistance</p>
          </div>

          <div className="safety-item">
            <div className="safety-img">
              <img src={tracking} alt="tracking" />
            </div>
            <p>Ride Tracking</p>
          </div>

          <div className="safety-item">
            <div className="safety-img">
              <img src={payment} alt="payment" />
            </div>
            <p>Transparent Payments</p>
          </div>

          <div className="safety-item">
            <div className="safety-img">
              <img src={community} alt="community" />
            </div>
            <p>Community Guidelines</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="driver-cta">
        <h3>
          Ready for a safe ride?
          <br />
          Book with Rolo Transit now."
        </h3>

        <div className="cta-buttons">



          <div style={{ position: "relative", display: "inline-block" }}>
  <button
    className="join"
    onClick={() => setShowDriverMenu(!showDriverMenu)}
  >
   Join as a Driver
  </button>
    {showDriverMenu && (
<div
  style={{
    position: "absolute",
    top: "110%",
    left: 0,
    minWidth: "220px",
    padding: "10px",
    borderRadius: "18px",
    background: "rgba(20, 20, 20, 0.95)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow:
      "0 10px 30px rgba(0,0,0,0.35), 0 0 20px rgba(252,147,68,0.15)",
    zIndex: 1000,
    overflow: "hidden",
  }}
>
  <a
    href="https://play.google.com/store/apps/details?id=com.rolocabs"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(61, 220, 132, 0.15)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-android"
      style={{
        color: "#3DDC84",
        fontSize: "22px",
      }}
    />
    Android
  </a>

  <a
    href="YOUR_IOS_APP_LINK"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.12)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-apple"
      style={{
        color: "#ffffff",
        fontSize: "22px",
      }}
    />
    iOS
  </a>
</div>
    )}
</div>


  
          <div style={{ position: "relative", display: "inline-block" }}>
  <button
    className="download"
    onClick={() => setShowDownloadMenu(!showDownloadMenu)}
  >
    Download Driver App
  </button>
    {showDownloadMenu && (
<div
  style={{
    position: "absolute",
    top: "110%",
    left: 0,
    minWidth: "220px",
    padding: "10px",
    borderRadius: "18px",
    background: "rgba(20, 20, 20, 0.95)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow:
      "0 10px 30px rgba(0,0,0,0.35), 0 0 20px rgba(252,147,68,0.15)",
    zIndex: 1000,
    overflow: "hidden",
  }}
>
  <a
    href="https://play.google.com/store/apps/details?id=com.rolo.rolocabsautobike"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(61, 220, 132, 0.15)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-android"
      style={{
        color: "#3DDC84",
        fontSize: "22px",
      }}
    />
    Android
  </a>

  <a
    href="https://apps.apple.com/in/app/rolo-cab-auto-bike/id6768391666"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.12)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-apple"
      style={{
        color: "#ffffff",
        fontSize: "22px",
      }}
    />
    iOS
  </a>
</div>
    )}
</div>

</div>
      </section>
      <section
        className="  rounded-0"
        style={{ maxWidth: "100%", color: "#FFFFFF" }}
      >
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-6 px-4 mb-4 mb-md-0">
            <div className="p-4">
              <h2
                className="text-bold"
                style={{
                  fontSize: "40px",
                  background:
                    "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: "50px",
                }}
              >
                {" "}
                Get in Touch with Rolo Transit
              </h2>
              <p>
                Please contact us for any questions, feedback, or potential
                collaboration. Let’s simplify easy and trushworthy city
                travelling. We are always here to support you, whether you are a
                rider, a driver, or a partner.
              </p>
              <div class="container mt-4">
                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col-auto">
                    <span className="fw-light">
                      4th Floor, Netcheck house/ Pasalkar Chembers, <br /> Sr.
                      no. 6/10, 401 to 404, behind Indian oil, <br /> Ambegaon
                      Budruk, Pune, Maharashtra 411041
                    </span>
                  </div>
                </div>

                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col">
                    <strong>General Support</strong>
                    <br />{" "}
                    <a
                      href="mailto:support@rolotransit.com"
                      className="fw-light"
                      style={{ fontSize: "16px", color: "inherit", textDecoration: "none" }}
                    >
                      support@rolotransit.com
                    </a>
                  </div>
                </div>

                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col">
                    <strong>Lets Talk:</strong>
                    <br /> <span className="fw-light">+91-7507500300</span>
                  </div>
                </div>

                <div className="d-flex gap-3 social-icons">
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={LinkedIn} alt="LinkedIn" />
                  </a>

                  <a
                    href="https://x.com/rolotransit?s=21"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={twitter} alt="Twitter" />
                  </a>

                  <a
                    href="https://www.instagram.com/rolotransit/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={insta} alt="Instagram" />
                  </a>

                  <a
                    href="https://www.facebook.com/rolotransit"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 px-4">
            <div className="p-4">
              <p>
                Fill the form and our team will get back to you at the earliest.
              </p>
      <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control custom-input"
                    placeholder="Your name"
                  
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                   
                    }}
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="you@example.com"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="+91-0000000000"
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                </div>

             <div className="mb-3">
  <label
    className="form-label fw-bold"
    style={{ fontWeight: "bold", fontSize: "14px" }}
  >
    *You are a
  </label>

 <select
  name="you_are"
  value={formData.you_are}
  onChange={handleChange}
  className="form-control"
  style={{
    backgroundColor: "#ffffff31",
    color: formData.you_are ? "#ffffff" : "#000000",
    borderColor: "#ffffff42",
  }}
>
  <option value="" style={{ color: "#000" }}>
    -Select-
  </option>

  <option value="Driver" style={{ color: "#000" }}>
    Driver
  </option>

  <option value="Individual" style={{ color: "#000" }}>
    Customer
  </option>

  {/* <option value="Organization" style={{ color: "#000" }}>
    Organization
  </option> */}
</select>
</div>
                {formData.you_are === "Organization" && (
                  <div className="mb-3">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Organization Name
                    </label>
                    <input
                      type="text"
                      name="organization_name"
                      value={formData.organization_name}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="Enter organization name"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                )}

                <div className="mb-3">
                  <label
                    htmlFor="message"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control custom-input"
                    rows="4"
                    placeholder="Your message..."
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  />
                   <span
                    style={{
                      fontSize: "12px",
                      color: "#FFFFFF",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    By using this website, you consent to our use of cookies and
                    collection of personal data as outlined in our Privacy
                    Policy.
                  </span>
                </div>

                <div className="mb-3">
                  <button
                    type="submit"
                    className="btn btn-dark rounded-pill py-2"
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
          
            </div>
          </div>
        </div>
      </section>
      <Footer />

      {/* CSS */}
      <style>{`
      
.custom-input {
  color: #ffffff !important;
}

.custom-input::placeholder {
  color: #000000 !important;
  opacity: 1;
}

.driver-page{
background:#000;
color:white;
font-family:Arial;
}

/* HERO */
.driver-hero{
height:80vh;
background-size:cover;
background-position:center;
display:flex;
align-items:center;
justify-content:center;
position:relative;
text-align:center;
}

.hero-overlay{
position:absolute;
inset:0;
background:rgba(0,0,0,0.45);
}

.hero-content{
position:relative;
max-width:"700px";
}

.hero-content h1{
font-size:60px;
color:#FC9344;
font-weight:700;
}

.hero-btn{
  width:524px;
  height:50px;

  background: linear-gradient(90deg, #D25A00 0%, #FF7F1F 100%);
  border:none;
  border-radius:25px;

  color:#fff;
  font-size:16px;
  font-weight:600;

  cursor:pointer;
  transition:0.3s;
}

/* Hover effect */
.hero-btn:hover{
  transform:translateY(-2px);
  box-shadow:0 6px 15px rgba(0,0,0,0.3);
}

/* WHY DRIVE */
.why-drive{
background:#FBEFE6;
color:#000;
padding:60px 10%;
}
.why-drive h2{
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 121%;
  letter-spacing: 0%;

  background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-bottom:40px;
}
  .why-card h4{
  width:224px;


  font-family:'Inter', sans-serif;
  font-weight:700;
  font-size:24px;
  line-height:121%;
  letter-spacing:0;

  color:#C25300;

  margin-bottom:10px;
}
  .why-card p{
  font-family:'Inter', sans-serif;
  font-size:16px;
  color:#333;
  line-height:1.5;
}

.why-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:30px;
  margin-top:30px;
}

.why-card{
  height:150px;
  background:#FFFFFF;
  border:1px solid #C25300;
  border-radius:20px;
  padding:25px;
  box-shadow:0px 5px 4.4px rgba(0,0,0,0.1);
}

/* hover effect (recommended for modern UI) */
.why-card:hover{
  transform:translateY(-5px);
  box-shadow:0 10px 20px rgba(0,0,0,0.15);
}
/* SECTION */
.earn-section {
  padding: 50px 5% 10px;
  background: #000;
}

.earn-section h2 {
  font-weight: 800;
  font-size: 36px;
  color: #FF7F1F;
  margin-bottom: 80px;
}

/* GRID */
.earn-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
   
  max-width: 700px;
  margin: auto;
}

/* PERFECT HONEYCOMB OFFSET */
.earn-grid .hex-wrapper:nth-child(4),
.earn-grid .hex-wrapper:nth-child(5),
.earn-grid .hex-wrapper:nth-child(6) {
  transform: translate(110px, -30px); 
}

/* HEX WRAPPER */
.hex-wrapper {
  width: 220px;
  height: 240px;
  position: relative;
  transform: translateY(10px); /* reduce vertical space */
}

/* OUTER HEX (ORANGE FRAME) */
.hex-border {
  position: relative;
  width: 100%;
  height: 100%;
  background: #FF8C32;

  clip-path: polygon(
    50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%
  );

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1;
}

.hex-border::before {
  content: "";
  position: absolute;
  inset: 0;

  background: #d96f1c;

  /* 🔥 ONLY RIGHT + BOTTOM SIDES */
  clip-path: polygon(
    95% 25%,   /* right top */
    100% 50%,
    95% 75%,   /* right bottom */
    50% 100%,  /* bottom */
    40% 90%,
    85% 70%,
    85% 30%,
    40% 10%
  );

  transform: translate(10px, 10px);

  z-index: -1;
}
 .hex-border::after {
  content: "";
  position: absolute;
  inset: 0;

  background: rgba(0,0,0,0.25);

  clip-path: inherit;

  transform: translate(18px, 18px);

  filter: blur(6px); /* 🔥 IMPORTANT */

  z-index: -2;
}
/* INNER WHITE HEX */
.hex-content {
  width: 80%;
  height: 80%;
  background: #F5F5F5;

  clip-path: inherit;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 18px;
  text-align: center;

  /* subtle inner depth */
  box-shadow: inset 0 6px 12px rgba(0,0,0,0.08);
}

/* ICON */
.hex-content img {
  width: 60px;
  height: 50px;
  margin-bottom: 12px;
}

/* TEXT */
.hex-content p {
  font-size: 16px;
  font-weight: 700;
  color: #D86100;
  line-height: 1.3;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .earn-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .earn-grid .hex-wrapper:nth-child(4),
  .earn-grid .hex-wrapper:nth-child(5),
  .earn-grid .hex-wrapper:nth-child(6) {
    transform: none;
  }
}

@media (max-width: 480px) {
  .earn-grid {
    grid-template-columns: 1fr;
  }
}
/* VEHICLES */
.vehicle-types{
padding:60px 10%;
}

.vehicle-types h2{
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 121%;
  letter-spacing: 0%;
  text-align: left;
  background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-bottom:40px;
}

.vehicle-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:30px;
  margin-top:40px;
}

.vehicle-card{
  width:280px;
  height:110px;

  background:#FFFFFF;
  color:#000;

  border:1px solid #C25300;
  border-radius:20px;

  padding:20px;

  display:flex;
  justify-content:space-between;
  align-items:center;

  box-shadow:0 5px 10px rgba(0,0,0,0.08);

  transition:all .3s ease;
}

/* hover effect (recommended) */
.vehicle-card:hover{
  transform:translateY(-5px);
  box-shadow:0 12px 25px rgba(0,0,0,0.15);
}
  .vehicle-card span{
  font-family:'Inter', sans-serif;
  font-weight:700;
  font-size:26px;
  color:#C25300;
}

.vehicle-card img{
  width:120px;
  object-fit:contain;
}

/* SAFETY */
.safety{
padding:20px 5%;
text-align:center;
}
.safety-item{
  display:flex;
  flex-direction:column;
  align-items:center;
  text-align:center;
  gap:15px;
}
.safety h2{
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 121%;
  letter-spacing: 0%;
  text-align: left;
  background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-bottom:40px;
}

.safety-img{
  width:150px;
  height:150px;

  border:2px solid #D25A00;
  border-radius:50%;

  display:flex;
  align-items:center;
  justify-content:center;

  overflow:hidden;
}

/* image inside circle */
.safety-img img{
  width:150px;
  height:150px;
  object-fit:contain;
}

.safety-grid{
  display:grid;
  grid-template-columns:repeat(5,1fr);
  gap:40px;
  margin-top:40px;
}
/* CTA */
.driver-cta{
text-align:center;
padding:60px 10%;
}
.driver-cta h3{
  max-width:555px;

  font-family:'Inter', sans-serif;
  font-weight:800;
  font-size:40px;
  line-height:121%;
  letter-spacing:0;

  text-align:center;

  background:linear-gradient(90deg,#FF7F1F 0%,#C25300 100%);
  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;

  margin:0 auto 10px auto;
}

.cta-buttons{
margin-top:50px;
display:flex;
justify-content:center;
gap:500px;
}

.join{
background:white;
color:black;
padding:10px 30px;
border:none;
border-radius:6px;
}

.download{
background:#ff8c32;
color:white;
padding:10px 30px;
border:none;
border-radius:6px;
}
.contact{
  background:#111;
  padding:80px 10%;
  color:#fff;
}

/* two column layout */
.contact-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:60px;
  align-items:flex-start;
}

/* left text section */
.contact-info p{
  color:#ccc;
  line-height:1.6;
  margin-bottom:15px;
}

/* form layout */
.contact-form{
  display:flex;
  flex-direction:column;
  gap:15px;
}

/* input fields */
.contact-form input,
.contact-form textarea{
  padding:12px;
  border-radius:8px;
  border:1px solid rgba(255,255,255,0.2);
  background:#69696966;
  color:#fff;
  font-size:14px;
}

/* placeholder color */
.contact-form input::placeholder,
.contact-form textarea::placeholder{
  color:#bbb;
}

/* button */
.contact-form button{
  background:linear-gradient(90deg,#D25A00 0%,#FF7F1F 100%);
  border:none;
  padding:14px;
  color:white;
  cursor:pointer;
  border-radius:8px;
  font-weight:600;
  transition:0.3s;
}

/* hover effect */
.contact-form button:hover{
  transform:translateY(-2px);
  box-shadow:0 6px 15px rgba(0,0,0,0.3);
}

/* social icons */
.social-icons{
  margin-top:20px;
  display:flex;
  gap:15px;
}

.social-icons img{
  width:40px;
  height:40px;
  object-fit:contain;
  transition:0.3s;
}

.social-icons img:hover{
  transform:scale(1.15);
}

`}</style>
    </div>
  );
}

export default BecomeDriver;
